import * as R from 'ramda'
import { filter } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as Actions from 'store/actions/index.ts'
import { getIsSaleFetched } from 'store/selectors'
import { isProductFetched } from 'domain/resources'

// type AwaitForProductFetched = (string, ActionsObservable, StateObservable) => ActionsObservable
export const awaitForProductFetched = (
  productKey,
  resourcesFetched$,
  state$
) => resourcesFetched$.pipe(
  filter(() => R.both(
    getIsSaleFetched,
    isProductFetched(productKey)
  )(state$.value))
)

// type AwaitForSaleFetched = (ActionsObservable, StateObservable) => ActionsObservable
export const awaitForSaleFetched = (actions$, state$) => (
  actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED), filter(() => getIsSaleFetched(state$.value)))
)
